(function () {
  "use strict";

  // ── Pure helpers (exported for tests) ──────────────────────────────────────

  function computeTargetSize(w, h, maxLongSide) {
    if (w <= maxLongSide && h <= maxLongSide) return { w: w, h: h };
    if (w >= h) return { w: maxLongSide, h: Math.round((h * maxLongSide) / w) };
    return { w: Math.round((w * maxLongSide) / h), h: maxLongSide };
  }

  function buildPropertyKey(index) {
    return "properties[Imagen " + index + "]";
  }

  // Translated strings injected from layout/theme.liquid (window.uploaderStrings).
  // Spanish fallbacks keep the uploader working if the injection is missing.
  function tr(key, fallback) {
    var s = window.uploaderStrings || {};
    return s[key] || fallback;
  }

  function fatalError(specificMsg) {
    // Rendered via textContent (no HTML), so the message must be plain text.
    return tr(
      "fatalError",
      "Ha ocurrido un error: [error]. Por favor, recarga la página e inténtalo de nuevo. Si el problema persiste, escríbenos a amapolalab.edit@gmail.com indicando el error y te ayudaremos.",
    ).replace("[error]", specificMsg);
  }

  // ── Compression ────────────────────────────────────────────────────────────

  function compressFile(file, maxLongSide, quality) {
    return createImageBitmap(file, { imageOrientation: "from-image" })
      .then(function (bitmap) {
        var dims = computeTargetSize(bitmap.width, bitmap.height, maxLongSide);
        var useOffscreen = typeof OffscreenCanvas !== "undefined";
        var canvas = useOffscreen
          ? new OffscreenCanvas(dims.w, dims.h)
          : document.createElement("canvas");
        if (!useOffscreen) {
          canvas.width = dims.w;
          canvas.height = dims.h;
        }

        var ctx = canvas.getContext("2d");
        ctx.drawImage(bitmap, 0, 0, dims.w, dims.h);
        if (bitmap.close) bitmap.close();

        var blobP = useOffscreen
          ? canvas.convertToBlob({ type: "image/jpeg", quality: quality })
          : new Promise(function (resolve, reject) {
              canvas.toBlob(
                function (b) {
                  b
                    ? resolve(b)
                    : reject(new Error("canvas.toBlob returned null"));
                },
                "image/jpeg",
                quality,
              );
            });

        return blobP.then(function (blob) {
          var name = file.name.replace(/\.[^.]+$/, ".jpg");
          return new File([blob], name, { type: "image/jpeg" });
        });
      })
      .catch(function (err) {
        if (err.message === "canvas.toBlob returned null") throw err;
        throw new Error(
          tr(
            "unsupportedBrowser",
            "Formato no soportado en este navegador. Convierte a JPG o PNG antes de subir.",
          ),
        );
      });
  }

  // ── Structured logs (no PII, no URLs) ─────────────────────────────────────

  window.__byamapolaCompressorLog = window.__byamapolaCompressorLog || [];
  window.__byamapolaUploadLog = window.__byamapolaUploadLog || [];

  function pushLog(arr, entry) {
    if (arr.length >= 50) arr.shift();
    arr.push(entry);
  }

  // ── Per-uploader initialisation ────────────────────────────────────────────

  function initUploader(uploader) {
    if (uploader._cartUploaderReady) return;
    uploader._cartUploaderReady = true;

    var form = uploader.closest("form");
    if (!form) {
      console.warn("[cart-uploader] No enclosing <form> found for", uploader);
      return;
    }

    var maxImages = parseInt(uploader.dataset.maxImages, 10) || 1;
    var maxLongSide = parseInt(uploader.dataset.maxLongSide, 10) || 2000;
    var quality = parseFloat(uploader.dataset.jpegQuality) || 0.85;
    // imagenes_requeridas is a boolean metafield: "true" or "false"
    var required = uploader.dataset.required === "true";

    var statusEl = uploader.querySelector("[data-cart-uploader-status]");
    var loadingGif = uploader.querySelector("[data-cart-uploader-loading-gif]");
    var errorEl = uploader.querySelector("[data-cart-uploader-error]");
    var submitBtn = form.querySelector('[type="submit"]');

    // Slot state: slotFiles[i] is File or null, where i is 1-based slot index.
    // Index 0 is unused (slots are 1..maxImages).
    var slotFiles = new Array(maxImages + 1).fill(null);
    var isSubmitting = false;
    var abortCtrl = null;

    // ── Shared UI helpers ───────────────────────────────────────────────────

    function setStatus(text, busy) {
      if (statusEl) statusEl.textContent = text;
      if (loadingGif) loadingGif.hidden = !busy;
    }

    function setError(message) {
      if (!errorEl) return;
      if (message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      } else {
        errorEl.hidden = true;
        errorEl.textContent = "";
      }
    }

    function setBusy(busy, label) {
      if (!submitBtn) return;
      var spinner = submitBtn.querySelector(".loading__spinner");
      if (busy) {
        if (submitBtn.dataset.origLabel === undefined) {
          var sp = submitBtn.querySelector("span");
          submitBtn.dataset.origLabel = sp ? sp.textContent : "";
        }
        submitBtn.classList.add("loading");
        submitBtn.setAttribute("aria-disabled", "true");
        submitBtn.disabled = true;
        if (spinner) spinner.classList.remove("hidden");
        if (label) {
          var sp = submitBtn.querySelector("span");
          if (sp) sp.textContent = label;
        }
      } else {
        submitBtn.classList.remove("loading");
        submitBtn.removeAttribute("aria-disabled");
        submitBtn.disabled = false;
        if (spinner) spinner.classList.add("hidden");
        var orig = submitBtn.dataset.origLabel;
        if (orig !== undefined) {
          var sp = submitBtn.querySelector("span");
          if (sp) sp.textContent = orig;
          delete submitBtn.dataset.origLabel;
        }
      }
    }

    function updateGlobalStatus() {
      var n = slotFiles.filter(Boolean).length;
      var template =
        n === 1
          ? tr("photosSelectedOne", "[count] foto seleccionada")
          : tr("photosSelectedOther", "[count] fotos seleccionadas");
      setStatus(n > 0 ? template.replace("[count]", n) : "");
    }

    // ── Per-slot wiring ─────────────────────────────────────────────────────

    uploader
      .querySelectorAll("[data-cart-uploader-slot]")
      .forEach(function (slot) {
        var slotIndex = parseInt(slot.dataset.slotIndex, 10);
        var input = slot.querySelector("[data-cart-uploader-input]");
        var thumb = slot.querySelector("[data-cart-uploader-thumb]");
        var removeBtn = slot.querySelector("[data-cart-uploader-remove]");
        var dropzone = slot.querySelector("[data-cart-uploader-dropzone]");

        if (!input) return;

        // Drag & drop onto the styled dropzone; routes the file through the
        // input's change handler so validation/preview logic is shared.
        if (dropzone) {
          ["dragenter", "dragover"].forEach(function (evtName) {
            dropzone.addEventListener(evtName, function (e) {
              e.preventDefault();
              dropzone.classList.add("is-dragover");
            });
          });
          ["dragleave", "drop"].forEach(function (evtName) {
            dropzone.addEventListener(evtName, function (e) {
              e.preventDefault();
              dropzone.classList.remove("is-dragover");
            });
          });
          dropzone.addEventListener("drop", function (e) {
            var files = e.dataTransfer && e.dataTransfer.files;
            if (files && files.length) {
              var dt = new DataTransfer();
              dt.items.add(files[0]);
              input.files = dt.files;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        }

        // File selection
        input.addEventListener("change", function (e) {
          // Cancel any in-flight upload when user changes a file.
          if (abortCtrl) {
            abortCtrl.abort();
            abortCtrl = null;
            isSubmitting = false;
            setBusy(false);
            setStatus("");
          }

          var file = this.files && this.files[0];

          if (!file) {
            updateGlobalStatus();
            return;
          }

          if (!file.type.startsWith("image/")) {
            // Clear any previous valid selection so the slot is not accidentally
            // submitted with the old file while the input shows the invalid name.
            if (thumb && thumb.src && !thumb.hidden) {
              URL.revokeObjectURL(thumb.src);
              thumb.src = "";
              thumb.hidden = true;
            }
            if (removeBtn) removeBtn.hidden = true;
            slot.classList.remove("has-image");
            this.value = "";
            slotFiles[slotIndex] = null;
            setError(
              tr(
                "unsupportedFormatSlot",
                "Formato no soportado en el espacio [slot]. Usa JPG, PNG o WEBP.",
              ).replace("[slot]", slotIndex),
            );
            updateGlobalStatus();
            return;
          }

          // Revoke previous preview URL before replacing it.
          if (thumb && thumb.src && !thumb.hidden) {
            URL.revokeObjectURL(thumb.src);
          }

          slotFiles[slotIndex] = file;
          slot.classList.remove("cart-uploader__slot--error");

          var url = URL.createObjectURL(file);
          if (thumb) {
            thumb.src = url;
            thumb.hidden = false;
          }
          if (removeBtn) removeBtn.hidden = false;
          slot.classList.add("has-image");

          setError(null);
          updateGlobalStatus();
        });

        // Remove button
        if (removeBtn) {
          removeBtn.addEventListener("click", function () {
            if (thumb && thumb.src && !thumb.hidden)
              URL.revokeObjectURL(thumb.src);
            if (thumb) {
              thumb.src = "";
              thumb.hidden = true;
            }
            removeBtn.hidden = true;
            slot.classList.remove("has-image");
            input.value = "";
            slotFiles[slotIndex] = null;
            slot.classList.remove("cart-uploader__slot--error");
            setError(null);
            updateGlobalStatus();
          });
        }
      });

    // ── Submit interception (capture phase) ────────────────────────────────

    form.addEventListener(
      "submit",
      function handleSubmit(evt) {
        // Let char-limit validation (product-form.js) handle its own error UX.
        if (submitBtn && submitBtn.classList.contains("validation-disabled"))
          return;

        // Build list of filled slots.
        var filledSlots = [];
        for (var i = 1; i <= maxImages; i++) {
          if (slotFiles[i]) filledSlots.push({ index: i, file: slotFiles[i] });
        }

        // Required validation: all slots must be filled.
        if (required) {
          var emptyIndices = [];
          for (var i = 1; i <= maxImages; i++) {
            if (!slotFiles[i]) emptyIndices.push(i);
          }
          if (emptyIndices.length > 0) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            // Red label on every empty slot; clear filled ones.
            for (var j = 1; j <= maxImages; j++) {
              var slotEl = uploader.querySelector(
                '[data-slot-index="' + j + '"]',
              );
              if (slotEl) slotEl.classList.toggle("cart-uploader__slot--error", !slotFiles[j]);
            }
            var missing = emptyIndices
              .map(function (n) {
                return tr("imageN", "Imagen [number]").replace("[number]", n);
              })
              .join(", ");
            setError(
              tr("missingImages", "Faltan imágenes obligatorias: [list].").replace(
                "[list]",
                missing,
              ),
            );
            var firstEmptyInput = uploader.querySelector(
              '[data-slot-index="' +
                emptyIndices[0] +
                '"] [data-cart-uploader-input]',
            );
            if (firstEmptyInput) firstEmptyInput.focus();
            return;
          }
        }

        // We own this submit from here on.
        evt.preventDefault();
        evt.stopImmediatePropagation();

        if (isSubmitting) return;
        isSubmitting = true;

        runSubmit(filledSlots)
          .catch(function (err) {
            if (err && err.name !== "AbortError") {
              console.error("[cart-uploader]", err.message || err);
            }
          })
          .finally(function () {
            isSubmitting = false;
          });
      },
      true,
    ); // capture phase

    // ── Main submit flow (async) ────────────────────────────────────────────

    async function runSubmit(filledSlots) {
      setError(null);

      var compressed = []; // [{ index, file }]

      // Phase 1 — compress each filled slot sequentially.
      if (filledSlots.length > 0) {
        var optimizingLabel = tr("optimizing", "Optimizando…");
        setBusy(true, optimizingLabel);
        setStatus("📸 " + optimizingLabel, true);

        var done = 0;
        var total = filledSlots.length;

        // Sequential (not Promise.all) so each slot's status text updates in
        // order and compression errors identify the exact failing slot clearly.
        try {
          for (var idx = 0; idx < filledSlots.length; idx++) {
            var slot = filledSlots[idx];
            var slotStatusEl = uploader.querySelector(
              '[data-slot-index="' +
                slot.index +
                '"] [data-cart-uploader-slot-status]',
            );
            if (slotStatusEl) slotStatusEl.textContent = optimizingLabel;

            let t0 = Date.now();
            try {
              var c = await compressFile(slot.file, maxLongSide, quality);
              compressed.push({ index: slot.index, file: c });
              done++;
              if (slotStatusEl) slotStatusEl.textContent = "✓ " + c.name;
              setStatus(
                "📸 " +
                  tr("progress", "[done] / [total] listas")
                    .replace("[done]", done)
                    .replace("[total]", total),
                true,
              );
              pushLog(window.__byamapolaCompressorLog, {
                ts: new Date().toISOString(),
                inputName: slot.file.name,
                originalSize: slot.file.size,
                compressedSize: c.size,
                durationMs: Date.now() - t0,
                status: "ok",
              });
            } catch (err) {
              if (slotStatusEl) slotStatusEl.textContent = "✗ " + err.message;
              pushLog(window.__byamapolaCompressorLog, {
                ts: new Date().toISOString(),
                inputName: slot.file.name,
                originalSize: slot.file.size,
                compressedSize: 0,
                durationMs: Date.now() - t0,
                status: "error",
                error: err.message,
              });
              throw err;
            }
          }
        } catch (compErr) {
          setBusy(false);
          setStatus("");
          setError(
            fatalError(
              compErr.message ||
                tr("processError", "No se pudo procesar una imagen."),
            ),
          );
          throw compErr;
        }
      }

      // Phase 2 — upload.
      var uploadingLabel = tr("uploading", "Subiendo al carrito…");
      setBusy(true, uploadingLabel);
      setStatus(uploadingLabel, true);

      var fd = new FormData(form);
      // Append each compressed file under its original slot index (1-based).
      compressed.forEach(function (item) {
        fd.append(buildPropertyKey(item.index), item.file, item.file.name);
      });

      var cart =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification");
      if (cart && typeof cart.getSectionsToRender === "function") {
        fd.append(
          "sections",
          cart
            .getSectionsToRender()
            .map(function (s) {
              return s.section || s.id;
            })
            .filter(Boolean)
            .join(","),
        );
        fd.append("sections_url", window.location.pathname);
        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(document.activeElement);
        }
      }

      abortCtrl = new AbortController();
      var t0Upload = Date.now();

      try {
        var data = await fetch("/cart/add.js", {
          method: "POST",
          body: fd,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          signal: abortCtrl.signal,
        }).then(function (res) {
          if (res.ok) return res.json();
          if (res.status === 413) {
            var e = new Error(
              tr(
                "tooLarge",
                "Las imágenes son demasiado grandes, intenta con menos fotos o menor resolución.",
              ),
            );
            e.status = 413;
            throw e;
          }
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              var msg =
                body.description ||
                body.message ||
                tr("httpError", "Error [status]. Vuelve a intentarlo.").replace(
                  "[status]",
                  res.status,
                );
              var e = new Error(msg);
              e.status = res.status;
              throw e;
            });
        });

        pushLog(window.__byamapolaUploadLog, {
          ts: new Date().toISOString(),
          productId: uploader.dataset.productId,
          fileCount: compressed.length,
          totalBytes: compressed.reduce(function (s, f) {
            return s + f.file.size;
          }, 0),
          status: "ok",
          durationMs: Date.now() - t0Upload,
        });

        setStatus("");
        setError(null);

        if (cart && typeof cart.renderContents === "function") {
          cart.renderContents(data);
        } else {
          window.location.href =
            window.Shopify && window.Shopify.routes
              ? window.Shopify.routes.cart_url
              : "/cart";
        }
      } catch (fetchErr) {
        if (fetchErr.name === "AbortError") throw fetchErr;

        pushLog(window.__byamapolaUploadLog, {
          ts: new Date().toISOString(),
          productId: uploader.dataset.productId,
          fileCount: compressed.length,
          totalBytes: compressed.reduce(function (s, f) {
            return s + f.file.size;
          }, 0),
          status: "error",
          durationMs: Date.now() - t0Upload,
          errorMessage: fetchErr.message,
        });

        setError(
          fatalError(
            fetchErr.message || tr("connectionError", "Error de conexión."),
          ),
        );
        throw fetchErr;
      } finally {
        setBusy(false);
        abortCtrl = null;
      }
    }
  }

  // ── Global init ────────────────────────────────────────────────────────────

  function initAll() {
    document.querySelectorAll("[data-cart-uploader]").forEach(initUploader);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches("[data-cart-uploader]")) {
          initUploader(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll("[data-cart-uploader]").forEach(initUploader);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);

  // Expose pure functions for unit tests only.
  if (typeof module !== "undefined") {
    module.exports = { computeTargetSize, buildPropertyKey };
  }
})();
